import { Select } from "@chakra-ui/react";
import { ReactNode } from "react";
import { FieldComponentProps } from "./types";

export function FieldSelect(props: FieldComponentProps): ReactNode {
  return (
    <Select
      id={props.id}
      name={props.label}
      onChange={(event) => {
        props.updateValue({ label: props.label, value: event.target.value });
      }}
      value={props.value}
    >
      <option value="" disabled>
        keine Option gewählt
      </option>
      {props.options?.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </Select>
  );
}
